import { configureStore } from '@reduxjs/toolkit'
import pipelineReducer from '@/features/adp/state/pipelineSlice'
import overlayReducer from '@/features/adp/state/overlaySlice'

export const store = configureStore({
  reducer: {
    pipeline: pipelineReducer,
    overlay: overlayReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
